export function runOnTrayChoiceChangedImplementation(
  _data: Record<string, unknown>,
  triggerOutPortFunctions: Map<string, () => void>) {
  
  const choice = _data.choice;
  if (!(choice instanceof EventTarget)) return;

  const onTrayChoiceChange = (event: Event) => {
    const detail = (event as CustomEvent<{ id: string; index: number }>).detail;
    _data.value = detail.id;
    triggerOutPortFunctions.get('onChange')?.();
    triggerOutPortFunctions.get(`onSelect_${detail.id}`)?.();
  };

  choice.addEventListener('traychoicechange', onTrayChoiceChange);
  return () => choice.removeEventListener('traychoicechange', onTrayChoiceChange);
}

